import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/atividades`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/atividades/${id}?include=user,responsavel,prospect`, options)
    .then(response => {
      let atividade = jsona.deserialize(response.data);
      delete atividade.links;
      return atividade;
    });
}

function add(atividade) {

  const payload = jsona.serialize({
    stuff: atividade,
    includeNames: ['prospects']
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/atividades?include=user,responsavel,prospect`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(atividade) {
  const payload = jsona.serialize({
    stuff: atividade,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/atividades/${atividade.id}?include=user,responsavel,prospect`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/atividades/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy
};

